import { OptionType } from 'components/CustomSelect/types';
import SheetAttributeManager from '../../../services/sheet-attribute-manager/SheetAttributeManager';

export interface AttributeOptionType extends OptionType<string> {}

export interface AttributeReferenceConfig {
    columns: AttributeOptionType[];
    rows: AttributeOptionType[];
    attributeMapper?: SheetAttributeManager
}

export const NEGATIVE_PREFIX = 'neg-';